export const Routes = Object.freeze({
  Start: '/',
  Index: 'index',
  Market: 'dealzone',
  Marketplace: 'marketplace',
  ProductSlug: 'p-slug',
  Category: 'c',
  CategorySlug: 'c-slug',
  Calculate: 'calculate',
  Pro: 'pro',
  Search: 'search',
  Quotes: 'quotes',
  QuotesSlug: 'quotes-slug',
  QuotesAllStores: 'quotes-all-stores',
  Blog: 'blog',
  BlogSlug: 'blog-slug',
  About: 'about-us',
  Checkout: {
    Cart: 'cart',
    Shipping: 'checkout',
    ShippingSlug: 'checkout-slug',
    Payment: 'payment',
    PaymentSlug: 'payment-slug',
    Confirm: 'confirm',
    ConfirmSlug: 'confirm-slug',
    Success: 'success',
    SuccessSlug: 'success-slug',
  },
  Reservation: {
    Success: 'reservation-success',
  },
  Login: 'login',
  Register: 'register',
  Payment: {
    Accept: 'payment-accept',
    Decline: 'payment-decline',
    Fail: 'payment-fail',
    Pay: 'payment-pay', // @TODO: Placeholder route.
  },
  Invoice: {
    Accept: 'invoice-accept',
    Decline: 'invoice-decline',
    // Fail: 'payment-fail',
    // Pay: 'payment-pay', // @TODO: Placeholder route.
  },
  ShipmentTracking: {
    Tracking: 'tracking',
    TrackingNumber: 'tracking-number',
  },
  Account: {
    AccountInformation: 'account-information',
    DeliveryAddresses: 'delivery-addresses',
    MyOrders: 'my-orders',
    MyOrdersSlug: 'my-orders-slug',
    SitePro: 'site-pro',
    SiteProDelivery: 'site-pro-delivery',
    SiteProPaymentId: 'site-pro-payment-id',
  },
  Balance: {
    Pay: 'balance/pay',
  },
  PrivacyPolicy: 'privacy-policy',
  PurchaseAgreement: 'purchase-agreement',
  PasswordReset: 'password-reset',
  Contacts: 'contacts',
  Faq: {
    Index: 'faq',
  },
  OrderForm: {
    Index: 'order-form',
    Summary: 'order-form-summary',
  },
  TrackingId: 'tracking-id',
  CreateOrderSlug: 'create-order-slug',
  OrderSuccessful: 'order-successful',
  OrderAdditionalInfoNeededSlug: 'order-additional-info-needed-slug',
  Warranty: 'warranty',
  ClaimForm: 'claim-form',
  ClaimFormPro: 'claim-form-pro',
  ReservationPolicy: 'reservation-policy',
  UnsupportedBrowser: 'unsupported-browser',
  SuccessSlug: 'success-slug',
})
